import { getCachedAppLanguage } from '@/lib/i18n/language-storage';
import { DEFAULT_LANGUAGE, normalizeLanguage, type AppLanguage } from '@/lib/i18n/constants';
import { getAccessToken, hasStoredUser } from '@/lib/auth-storage';

/**
 * Logged-out: cached guest choice (login/landing).
 * Logged-in: UserSettings.language from API only (not stale cache).
 */
export function resolveAppLanguage(options: {
  isAuthenticated: boolean;
  settingsLanguage?: string | null;
  settingsLoaded: boolean;
}): AppLanguage {
  if (!options.isAuthenticated) {
    return getCachedAppLanguage();
  }
  if (!options.settingsLoaded) {
    return getCachedAppLanguage();
  }
  if (options.settingsLanguage?.trim()) {
    return normalizeLanguage(options.settingsLanguage);
  }
  return DEFAULT_LANGUAGE;
}

export function isAuthenticatedClient(): boolean {
  return typeof window !== 'undefined' && (!!getAccessToken() || hasStoredUser());
}

export { DEFAULT_LANGUAGE };
